var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-scene',{attrs:{"id":"scene","vr-mode-ui":"enabled: false"}},[_c('a-sky',{attrs:{"id":"sky","src":_vm.getFirstPracticeIntroPosterMin(),"data-src":_vm.getFirstPracticeIntroPoster()}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }